
import AutoAskQuesionIcon from '@/components/finagent/icons/AutoAskQuesionIcon';
import ChatIcon from '@/components/finagent/icons/ChatIcon';
import SnippetIcon from '@/components/finagent/icons/SnippetIcon';
import WishListIcon from '@/components/finagent/icons/WishListIcon';

const tabKeys = {
    chat: 'chat',
    library: 'library',
    wishlist: 'watchlist',
    recurring: 'recurring',
};

export default {
    name: 'FinAgentNavigationBar',

    components: {
        ChatIcon,
        SnippetIcon,
        WishListIcon,
        AutoAskQuesionIcon,
    },

    data() {
        return {
            activeTab: null,
        }
    },

    computed: {
        isFinAgentLibrary() {
            return this.$isFinAgentLibraryPage(this.$route);
        },
        isFinAgentWishList() {
            return this.$isFinAgentWishListPage(this.$route);
        },
        isFinAgentAutoAskQuestionsPage() {
            return this.$isFinAgentAutoAskQuestionsPage(this.$route);
        },
    },
    
    watch: {
        '$route': {
            immediate: true,
            handler() {
                if (this.isFinAgentLibrary) {
                    this.activeTab = tabKeys.library;
                    return;
                }

                if (this.isFinAgentWishList) {
                    this.activeTab = tabKeys.wishlist;
                    return;
                }

                if (this.isFinAgentAutoAskQuestionsPage) {
                    this.activeTab = tabKeys.recurring;
                    return;
                }

                this.activeTab = tabKeys.chat;
            }
        }
    },

    created() {
        this.tabKeys = tabKeys;
    }
}
